import axios from "axios";


const baseURL = window.API_BASE_URL != "" ? window.API_BASE_URL : "https://m.pagglo.com/api";
export const axiosApi = axios.create({ baseURL });

axiosApi.defaults.headers.common["Content-Type"] = "application/json";
axiosApi.defaults.headers.common["Authorization"] = `Bearer ${sessionStorage.getItem("token")}`;


export const setAuthHeader = token => {
    axiosApi.defaults.headers.common["Authorization"] = `Bearer ${token}`;
};

export default axiosApi;

export class ApiCartoesService {

    constructor() {

    }

    getListaCartoes() {
        setAuthHeader(sessionStorage.getItem("token"))
        const url = `/v1/cartao`;
        return axiosApi.get(url).then(response => response.data);
    }

    getListaCartoesCompra() {
        setAuthHeader(sessionStorage.getItem("token"))
        const url = `/v1/cartao-compras/listar`;
        return axiosApi.get(url).then(response => response.data);
    }
    getDadosSolicitacaoCartaoBeneficio(contaId) {
        setAuthHeader(sessionStorage.getItem("token"))
        const url = `/v2/cartao/obter-dados/solicitar-cartao/${contaId}`;
        return axiosApi.get(url).then(response => response.data);
    }

    solicitacaoCartao(solicitacaoCartao) {
        setAuthHeader(sessionStorage.getItem("token"))
        const url = `/v2/cartao/solicitar-cartao`;
        return axiosApi.post(url, solicitacaoCartao).then(response => response.data);
    }

    cadastrarCartao(cartaoToken) {
        setAuthHeader(sessionStorage.getItem("token"))
        const url = `/v3/integracao/usuario/conta/carteira/cartao/cadastrar`;
        return axiosApi.post(url, cartaoToken).then(response => response.data);
    }
    removerCartao(codigoCartao) {
        setAuthHeader(sessionStorage.getItem("token"))
        const url = `/v1/cartao/remover/${codigoCartao}`;
        return axiosApi.post(url, codigoCartao).then(response => response.data);
    }
    obterCartao(codigoCartao) {
        setAuthHeader(sessionStorage.getItem("token"))
        const url = `/v1/cartao/${codigoCartao}`;
        return axiosApi.get(url).then(response => response.data);
    }
    gerarSenhaCartaoCompras(contaId) {
        setAuthHeader(sessionStorage.getItem("token"))
        const url = `/v2/cartao/gerar-senha-cartao-compras/${contaId}`;
        return axiosApi.get(url).then(response => response.data);
    }

    desbloquearCartaoFisico(dadosCartao) {
        setAuthHeader(sessionStorage.getItem("token"))
        const url = `/v2/cartao/cartao-fisico/desbloquear`;
        return axiosApi.post(url, dadosCartao).then(response => response.data);
    }
}